import { VIEWER_SET_URLS } from '../constants/action-types/viewer';

export const viewerSetUrls = objectWithUrls => {
  return {
    type: VIEWER_SET_URLS,
    payload: objectWithUrls,
  };
};
